import React from "react";

const PaginationComponent = ({ count, page, setPage }) => {
  const totalPages = Math.ceil(count / 8);

  // Helper function to generate pages to show
  const getVisiblePages = () => {
    let visiblePages = [];

    // If total pages are less than or equal to 5, show all
    if (totalPages <= 3) {
      visiblePages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      // Always show the first page, the last page, and the current page
      visiblePages.push(1);

      // For current page, show 2 pages before and after if possible
      if (page > 2) {
        visiblePages.push(page - 1);
      }
      visiblePages.push(page);

      if (page < totalPages - 1) {
        visiblePages.push(page + 1);
      }

      visiblePages.push(totalPages);

      // Eliminate duplicates and sort the pages in ascending order
      visiblePages = [...new Set(visiblePages)].sort((a, b) => a - b);

      // Add ellipsis if there's a gap
      if (visiblePages[1] !== 2) {
        visiblePages.splice(1, 0, '...');
      }
      if (visiblePages[visiblePages.length - 2] !== totalPages - 1) {
        visiblePages.splice(visiblePages.length - 1, 0, '...');
      }
    }

    return visiblePages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="pagination-box d-flex align-items-center justify-content-between mt-3">
      <ul className="pagination mb-0">
        {/* Previous Button */}
        <li className={`page-item prev-btn${page === 1 ? " disabled" : ""}`}>
          <button className="page-link previous" onClick={() => setPage(page - 1)} disabled={page === 1}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20">
              <g>
                <path fill="#ff3d00" d="M67.25 8.853a3 3 0 0 1 4.243 4.242L34.589 50l36.905 36.906a3 3 0 1 1-4.243 4.242L28.507 52.403a2.994 2.994 0 0 1-.866-2.396c-.083-.861.206-1.75.865-2.41z" />
              </g>
            </svg>
          </button>
        </li>

        {/* Page Numbers */}
        {visiblePages.map((pageNumber, idx) => (
          <li key={pageNumber + idx} className={`page-item${page === pageNumber ? "active" : ""}${pageNumber === '...' ? " disabled" : ""}`}>
            <button
              className={`page-link ${pageNumber === '...' ? 'disabled' : ''}`}
              onClick={() => pageNumber !== '...' && setPage(pageNumber)}
              disabled={pageNumber === '...'}
            >
              {pageNumber}
            </button>
          </li>
        ))}

        {/* Next Button */}
        <li className={`page-item next-btn${page === totalPages ? " disabled" : ""}`}>
          <button className="page-link next" onClick={() => setPage(page + 1)} disabled={page === totalPages}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20">
              <g>
                <path fill="#ff3d00" d="M32.75 8.853a3 3 0 0 0-4.243 4.242L65.411 50 28.506 86.906a3 3 0 1 0 4.243 4.242L71.493 52.403c.574-.573.866-1.352.866-2.396s-.292-1.823-.866-2.41z" />
              </g>
            </svg>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationComponent;
